import { render, staticRenderFns } from "./org.vue?vue&type=template&id=49ac0ea9&scoped=true&"
import script from "./org.vue?vue&type=script&lang=js&"
export * from "./org.vue?vue&type=script&lang=js&"
import style0 from "./org.vue?vue&type=style&index=0&id=49ac0ea9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ac0ea9",
  null
  
)

export default component.exports